export default "__VITE_ASSET__DCNfGyDX__"